export const ASK_PUNTT_CAMPAIGN_PATH = "/ask-puntt/projects/$projectId";
export const ASK_PUNTT_CHAT_PATH = "/ask-puntt/$chatId";

export type AskPunttChatNavSource = {
  _id: string;
  projectId?: string | null;
  projectChatKind?: "shared" | "personal" | null;
};

export function isProjectPersonalChat(chat: AskPunttChatNavSource): boolean {
  return Boolean(chat.projectId && chat.projectChatKind === "personal");
}

export function askPunttChatNavLink(chat: AskPunttChatNavSource) {
  if (isProjectPersonalChat(chat)) {
    return {
      to: ASK_PUNTT_CAMPAIGN_PATH,
      params: { projectId: chat.projectId! },
      search: { chatId: chat._id },
    } as const;
  }
  return {
    to: ASK_PUNTT_CHAT_PATH,
    params: { chatId: chat._id },
  } as const;
}

export function isAskPunttChatNavActive(
  chat: AskPunttChatNavSource,
  matches: { pathname: string }[],
  locationSearch?: Record<string, unknown>,
): boolean {
  if (isProjectPersonalChat(chat)) {
    const onProject = matches.some(
      (m) => m.pathname === `/ask-puntt/projects/${chat.projectId}`,
    );
    if (!onProject) return false;
    const searchChatId =
      typeof locationSearch?.chatId === "string"
        ? locationSearch.chatId
        : undefined;
    return searchChatId === chat._id;
  }
  return matches.some((m) => m.pathname === `/ask-puntt/${chat._id}`);
}

export function isViewingAskPunttChat(
  chat: AskPunttChatNavSource,
  pathname: string,
  searchParams: URLSearchParams,
): boolean {
  if (isProjectPersonalChat(chat)) {
    return (
      pathname === `/ask-puntt/projects/${chat.projectId}` &&
      searchParams.get("chatId") === chat._id
    );
  }
  return pathname.includes(`/ask-puntt/${chat._id}`);
}
